export default __webpack_public_path__ + "static/media/doc.e818bda0.svg";